import { useMemo } from 'react';
import { CurrentPrice, OldPrice, PriceRoot } from "./styles";
import { OFFER, PRODUCT_TILE_CURRENT_PRICE, PRODUCT_TILE_OLD_PRICE } from "../../common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Price = function Price(_ref) {
  var _labels$deal2;
  var currentPrice = _ref.currentPrice,
    labels = _ref.labels,
    oldPrice = _ref.oldPrice;
  var isOffer = useMemo(function () {
    var _labels$deal;
    return (labels === null || labels === void 0 || (_labels$deal = labels.deal) === null || _labels$deal === void 0 ? void 0 : _labels$deal.labelKey) === OFFER && Boolean(oldPrice);
  }, [labels === null || labels === void 0 || (_labels$deal2 = labels.deal) === null || _labels$deal2 === void 0 ? void 0 : _labels$deal2.labelKey, oldPrice]);
  if (!currentPrice) {
    return null;
  }
  return /*#__PURE__*/_jsxs(PriceRoot, {
    children: [/*#__PURE__*/_jsx(CurrentPrice, {
      "data-testid": PRODUCT_TILE_CURRENT_PRICE,
      isOffer: isOffer,
      children: currentPrice
    }), oldPrice ? /*#__PURE__*/_jsx(OldPrice, {
      "data-testid": PRODUCT_TILE_OLD_PRICE,
      children: oldPrice
    }) : null]
  });
};
//# sourceMappingURL=Price.js.map